module.exports = __webpack_public_path__ + "static/media/Gfx-More-Information.d23e71c4.svg";